module.exports = __webpack_public_path__ + "static/media/passions.e0cbb5ea.png";